import { render, staticRenderFns } from "./DashUpload.vue?vue&type=template&id=16ec1b70"
import script from "./DashUpload.vue?vue&type=script&lang=js"
export * from "./DashUpload.vue?vue&type=script&lang=js"
import style0 from "./DashUpload.vue?vue&type=style&index=0&id=16ec1b70&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports